export default [
  {
    type: 'generalValidation',
    message: 'This field should not contain html tags'
  },
  {
    type: 'required',
    message: 'This field is required'
  },
  {
    type: 'email',
    message: 'This field should contain a valid email'
  },
  {
    type: 'customEmail',
    message: 'This field should contain a valid email'
  },
  {
    type: 'corporateEmail',
    message: 'Please enter a valid corporate email address'
  },
  {
    type: 'minValue',
    message: 'This field should be bigger than 0'
  },
  {
    type: 'maxValue',
    message: 'This field should be less than 100'
  },
  {
    type: 'url',
    message:
      'This field should contain a valid url. Example: "https://www.site.com/"'
  },
  {
    type: 'https',
    message: 'Do not put here an HTTP link. Only HTTPS links will be accepted'
  },
  {
    type: 'phone',
    message:
      'Full phone number should start with "+" and contain from 6 to 16 digits'
  },
  {
    type: 'anyTruthy',
    message: 'At least one selected option is required'
  }
]
